// extracted by mini-css-extract-plugin
module.exports = {"feature":"FeatureMessagesDrawerFeature_feature__IuLlW"};